import './MetadataInputComponent.css';
import '../../tabs/assets/AssetsDetailsStyle.css';

import React from 'react';
import _ from 'lodash';
import { findDOMNode } from 'react-dom';
import Portal from './../../common/Portal';
import MetadataUtil from '../../util/MetadataUtil';
import StringUtil from '../../util/StringUtil';
import PropTypes from 'prop-types';
import moment from 'moment';
import DatePicker from '../../common/form/DatePicker';
import ReactSelect from '../../tabs/ReactSelect';
import { GetMetadataHelpQueryMsg, GetMetadataHelpQueryQuery } from '../../autogenerated/ZoomBridge';
import { KeyCode } from '../../util/Constants';
import t from '../../i18n/I18n';
import Dropdown from '../../common/Dropdown';
import { ThemeSetup } from '../../themes/ThemeSetup';

const debug = require('../../debug/debug')('wc:metadata:MetadataInputComponent');

export default class MetadataInputComponent extends React.Component {
  state = {
    showAutoComplete: false,
    autoCompleteValues: null
  };

  static propTypes = {
    propInfo: PropTypes.object,
    propValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onChangeHandler: PropTypes.func,
    onKeyDownEnter: PropTypes.func,
    editable: PropTypes.bool,
    fullPropName: PropTypes.string,
    anchor: PropTypes.string,
    name: PropTypes.string,
    onFilterChangeHandler: PropTypes.func, //Called Function when Change in Advance Filter
    propField: PropTypes.object, // Metadata field indetify
    filterIndex: PropTypes.number, //  Filter Index number
    advanceSearchForm: PropTypes.bool, // Boolean for Check form for Advance Search or Use something else.
    onFieldChangeHandler: PropTypes.func, //Handle field change value
    index: PropTypes.number //Index number of form
  };

  constructor(props) {
    super(props);

    this.state = {
      value: null,
      options: this.getOptionsValueforDropdown()
    };
    this.changeDate = props.propValue;
    this.delayedIssueQuery = _.debounce((value) => {
      this.issueQueryToGetAutoCompleteValues(value);
    }, 300);
  }

  componentDidMount() {
    const { options } = this.state;
    const selected = _.find(options, (o) => o.label === this.props.propValue);
    const value = selected ? selected.value : this.props.propValue;
    this.setState({
      value
    });
  }

  onChangeHandler(value) {
    this.delayedIssueQuery(value);
    //Check if function pass through props or not...
    if (this.props.onFilterChangeHandler) {
      const { propField, filterIndex } = this.props;
      this.props.onFilterChangeHandler(value, propField, filterIndex);
    } else {
      this.props.onChangeHandler(value);
      this.onFieldChange(value);
    }
  }
  //Handle Field Value.
  onFieldChange = (value: string) => {
    if (this.props.onFieldChangeHandler) {
      this.props.onFieldChangeHandler(this.props.index, value);
    }
  };

  onKeyDown(event: KeyboardEvent, pattern) {
    const { onKeyDownEnter } = this.props;
    if (event.keyCode === KeyCode.ENTER) {
      if (onKeyDownEnter) {
        event.stopPropagation();
        event.preventDefault();
        onKeyDownEnter();
      }
    } else if (pattern !== undefined) {
      if (!pattern.test(event.key)) {
        if (event.preventDefault) event.preventDefault(); //normal browsers
      }
    }
  }

  renderAutoCompleteOptions(key, value) {
    return (
      <li
        key={key}
        className="option"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          this.onAutoCompleteValueSelected(value);
        }}>
        <div className="label">{value}</div>
      </li>
    );
  }

  onAutoCompleteValueSelected(value) {
    this.props.onChangeHandler(value);
    this.refs.inputFieldComponent.value = value;
    this.setShowAutoComplete(false);
    this.refs.inputFieldComponent.focus();
  }

  issueQueryToGetAutoCompleteValues(value) {
    const query = new GetMetadataHelpQueryQuery();
    const msg = new GetMetadataHelpQueryMsg();
    msg.setMetadataProperty(this.props.fullPropName);
    msg.setPrefix(value);
    query.message = msg;
    debug('[issueQueryToGetAutoCompleteValues()] running query: ', query);
    query.run().then(
      (resp) => {
        debug('[issueQueryToGetAutoCompleteValues()] response: ', resp);
        if (resp.isSuccess()) {
          this.setAutoCompleteValue(resp.getEntries());
          this.setShowAutoComplete(true);
        } else {
          this.setAutoCompleteValue(null);
        }
      },
      (error) => {
        if (!error) error = 'An error occurred while reading autocomplete values for prop ' + this.props.fullPropName;
        debug('[issueQueryToGetAutoCompleteValues()] error: ', error);
        this.setAutoCompleteValue(null);
      }
    );
  }

  setAutoCompleteValue(vals) {
    this.setState({ autoCompleteValues: vals });
  }

  setShowAutoComplete(val) {
    this.setState({ showAutoComplete: val });
  }

  onClose = () => {
    this.setShowAutoComplete(false);
  };

  onBackgroundClick = (e: MouseEvent) => {
    if (e.target === e.currentTarget) {
      this.onClose();
    }
  };

  onDateChange = (value) => {
    this.changeDate = value;
    this.props.onChangeHandler(value);
    if (!this.props.advanceSearchForm) {
      this._datepicker.setState({ value: value ? moment(value) : value });
    }
    this.forceUpdate();
  };

  onDatepickerRef = (inst) => {
    const { name } = this.props;
    this._datepicker = inst;
    if (inst && name) {
      const node = findDOMNode(inst);
      if (node) {
        const input = node.querySelector('input');
        if (input && !input.getAttribute('name')) {
          input.setAttribute('name', name);
        }
      }
    }
  };

  getTimeStampFromDate(date: string): int {
    return new Date(date).getTime();
  }

  parseTimeStampWithMoment(timestamp: string): int {
    return moment(parseInt(timestamp));
  }
  onValueChangeHandler = (value) => {
    const { options } = this.state;
    this.setState({
      value: value
    });
    const label = value || value === 0 ? _.find(options, { value }).label : '';
    this.props.onChangeHandler(label);
  };

  randerDateFields = () => {
    let dateTimeStamp = this.props.propValue;
    const regexp = new RegExp('/');
    if (dateTimeStamp != '' && regexp.test(dateTimeStamp)) dateTimeStamp = this.getTimeStampFromDate(dateTimeStamp);
    const isMultipleValuetext = this.props.propValue && this.props.propValue === MetadataUtil.MULTIPLE_VALUES;
    let newProps = {
      onChange: this.onDateChange,
      value: this.props.propValue,
      disabled: this.props.editable ? '' : 'disabled',
      ref: this.onDatepickerRef,
      selected: this.props.propValue
        ? isMultipleValuetext
          ? undefined
          : this.parseTimeStampWithMoment(dateTimeStamp)
        : undefined,
      placeholder: isMultipleValuetext ? MetadataUtil.MULTIPLE_VALUES : '',
      fieldName: this.props.name,
      popperPlacement: 'top-start'
    };
    if (this.props.advanceSearchForm) return <RanderDatePicker {...newProps} />;
    else
      return (
        <div name="TextArea">
          <div className="date-picker">
            <DatePicker {...newProps} />
          </div>
          <div className="cross-btn">
            {this.changeDate  ?  (
                <img
                  className="remove"
                  onClick={() => this._datepicker.clearDate()}
                  src={ThemeSetup.getImageURL('remove.svg')}
                />
              ) : null
          }
          </div>
        </div>
      );
  };

  //TODO : for Refactor Complex AutoComplate Component.
  randerAutocomplete = () => {};

  resetValue = () => {
    this.setState({
      value: null
    });
    this.onValueChangeHandler(null);
  };

  getOptionsValueforDropdown = () => {
    let options = [];
    if (this.props.propInfo !== undefined && this.props.propInfo._possibleValues.length > 0) {
      _.map(this.props.propInfo._possibleValues, (val, index) => {
        options.push({ value: index, label: val });
      });
    }
    return options;
  };

  resetInputFeild = () => {
    this.refs.inputFieldComponent.value = null;
    this.onChangeHandler();
  };

  isInputFieldEmpty = () => {
    if (this.refs.inputFieldComponent) {
      return this.refs.inputFieldComponent.value ? false : true;
    }
  };

  render() {
    const { anchor, name } = this.props;
    let { value } = this.state;
    switch (this.props.propInfo === undefined ? 'string' : this.props.propInfo._userCanType) {
      case 'date':
        return this.randerDateFields();
      default:
        if (this.props.propInfo === undefined || this.props.propInfo._possibleValues.length === 0) {
          let __pattern = undefined;
          if (this.props.propInfo !== undefined) {
            const propPattern = this.props.propInfo.getValueRestrictPattern();
            if (StringUtil.isEmpty(propPattern)) {
              __pattern = window.gs.globalMetadataRestrictPattern;
            } else {
              __pattern = propPattern;
            }

            if (__pattern !== undefined) {
              __pattern = new RegExp(__pattern, 'i');
            }
          }

          const rect = this.refs.inputSearchField ? this.refs.inputSearchField.getBoundingClientRect() : {};
          const style = { top: rect.bottom, minWidth: rect.width };
          if (anchor === 'RIGHT') {
            style.right = window.innerWidth - rect.right;
          } else {
            style.left = rect.left;
          }

          return (
            <div ref="inputSearchField" name="MetadataInputComponent">
              <div name="TextArea">
                <input
                  ref="inputFieldComponent"
                  onKeyDown={(event) => this.onKeyDown(event, __pattern)}
                  type="text"
                  name={name}
                  defaultValue={this.props.propValue}
                  onChange={(event) => this.onChangeHandler(event.target.value)}
                  disabled={this.props.editable ? '' : 'disabled'}
                />

                {!this.isInputFieldEmpty() ? (
                  <img className="remove" onClick={this.resetInputFeild} src={ThemeSetup.getImageURL('remove.svg')} />
                ) : null}
              </div>

              {this.state.showAutoComplete && !_.isEmpty(this.state.autoCompleteValues) ? (
                <Portal defaultOpen={true} closeOnEsc={true} onClose={this.onClose}>
                  <div className="transparent-background" onClick={this.onBackgroundClick}>
                    <ul name="Dropdown_List" style={style}>
                      {_.map(this.state.autoCompleteValues, (val, index) => this.renderAutoCompleteOptions(index, val))}
                    </ul>
                  </div>
                </Portal>
              ) : null}
            </div>
          );
        } else {
          let placeHolderText;
          placeHolderText =
            this.props.propValue === MetadataUtil.MULTIPLE_VALUES ? MetadataUtil.MULTIPLE_VALUES : t('SELECT_DOTS');
          return (
            <Dropdown
              value={!isNaN(value) ? value : null}
              options={this.state.options}
              onChange={(value) => this.onValueChangeHandler(value)}
              className="sideBySideInput boxedDropDown inputText"
              style={{ padding: '0 10px' }}
              clearable={true}
              resetValue={this.resetValue}
              placeholder={placeHolderText}
              crossImgSrc={ThemeSetup.getImageURL('remove.svg')}
            />
          );
        }
    }
  }
}

const RanderDatePicker = (props: randerDatePickerProps) => {
  return (
    <DatePicker
      onChange={props.onChange}
      value={props.value}
      disabled={props.disabled}
      fieldName={props.fieldName}
      range={true}
      placeholder='Any'
    />
  );
};

type randerDatePickerProps = {
  onChange: func,
  value: ?string,
  disabled: ?string,
  fieldName: ?string
};

//TODO:
const RanderAutocompleteField = (props) => {
  return <div></div>;
};
